import { render, staticRenderFns } from "./jianjie.vue?vue&type=template&id=0ad8bf93&scoped=true"
import script from "./jianjie.vue?vue&type=script&lang=js"
export * from "./jianjie.vue?vue&type=script&lang=js"
import style0 from "./jianjie.vue?vue&type=style&index=0&id=0ad8bf93&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad8bf93",
  null
  
)

export default component.exports